import { CreateNewCalendarEventModal } from "./CreateNewCalendarEventModal";

export default CreateNewCalendarEventModal;
